import "./logo.css";

const Logo = ({ brandName, cl = "" }) => {
  return (
    <>
      <img
        className={cl ? " " + cl : ""}
        src={`${process.env.REACT_APP_UPLOAD_URL}${brandName}`}
        alt="logo"
      />
    </>
  );
};

export default Logo;
